module.exports = __webpack_public_path__ + "img/center back length from empire seam to hem.7221c727.png";